import { CustomReport } from "@/components/CustomReports/models/CustomReport";
import { CustomReportsJsonParsingInputType } from "@/components/CustomReports/services/CustomReportsJsonParsingService";
import { IQueueExecutionCustomReportsProp } from "@/shared/Executions/models/IQueueExecutionRequest";
import { CdnSchemaJsonParsingResult } from "../models/CdnSchemaJsonParsingResult";
import { SchemaCoalesceService } from "./SchemaCoalesceService";


export class CustomReportsSchemaCoalesceService extends SchemaCoalesceService<CustomReport, CustomReportsJsonParsingInputType, IQueueExecutionCustomReportsProp> {

    public coalesceParsingResultparsingResult(parsingResult: CdnSchemaJsonParsingResult<CustomReport, CustomReportsJsonParsingInputType>): IQueueExecutionCustomReportsProp {
        if (parsingResult == null) throw Error("parsingResult is required");
        if (!parsingResult.valid) throw Error("valid parsingResult required");

        const coalesceResult: IQueueExecutionCustomReportsProp = {
            reports: parsingResult.parsedEntities ?? []
        };

        return coalesceResult;
    }

}
